<template>
  <section>
    <router-view></router-view>
  </section>
</template>

<style lang="scss" scoped>
body {
  margin: 0 !important;
  width: 100vw;
  height: 100vh;
  background-color: #f3f3f3;
  overflow-x: hidden !important;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0.5;
  transform: translateX(20px);
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}

.fade-enter-active {
  transition: all 1.2s ease;
}

.fade-enter-active {
  transition: all .5s cubic-bezier(1, 0.6, 0.6, 1);
}

.el-main {
  background-color: #fff;
  border-radius: 5px;
}

.window-height-100 {
  height: 100%;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  width: 100%;
}

nav {
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>

<script setup name="App">
import {onMounted} from "vue"
import {useStorage} from '@vueuse/core'
import {useRouter} from 'vue-router';

const router = useRouter()
let nowtime_ = Date.parse(new Date().toLocaleString())//现在时间
let login_time = Date.parse(useStorage('login_time').value)//登录时间
if (nowtime_ / 1000 - login_time / 1000 >= 86400) {

} else {

}
let token = useStorage('token')
if (token.value == false) {
  router.push('/home')
}
const ignoreErrors = ["ResizeObserver loop completed with undelivered notifications", "ResizeObserver loop limit exceeded"]
window.addEventListener('error', e => {
  let errorMsg = e.message;
  ignoreErrors.forEach(m => {
    if (errorMsg.startsWith(m)) {
      if (e.error) {
      }
      const resizeObserverErrDiv = document.getElementById(
        'webpack-dev-server-client-overlay-div'
      );
      const resizeObserverErr = document.getElementById(
        'webpack-dev-server-client-overlay'
      );
      if (resizeObserverErr) {
        resizeObserverErr.setAttribute('style', 'display: none');
      }
      if (resizeObserverErrDiv) {
        resizeObserverErrDiv.setAttribute('style', 'display: none');
      }
    }
  })
});
;(function () {
  if (typeof EventTarget !== 'undefined') {
    const func = EventTarget.prototype.addEventListener
    EventTarget.prototype.addEventListener = function (type, fn, capture) {
      ;(this).func = func
      if (typeof capture !== 'boolean') {
        capture = capture || {}
        capture.passive = false
      }
      ;(this).func(type, fn, capture)
    }
  }
})()
// const debounce = (fn, delay) => {
//   let timer = null;
//   return function () {
//     let context = this;
//     let args = arguments;
//     clearTimeout(timer);
//     timer = setTimeout(function () {
//       fn.apply(context, args);

//     }, delay);
//   }
// }

// const _ResizeObserver = window.ResizeObserver;
// window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
//   constructor(callback) {
//     callback = debounce(callback, 16);
//     super(callback);
//   }
// }

onMounted( () => {
  const cur_host = window.location.hostname
  fetch('hosticp.json').then(async (response) => {
    let data = await response.json();
    data.map((item) => {
      if (item.host == cur_host) {
        document.title = item.name;
      }
    })
  })
})
</script>
